import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['btn', 'tab']

  connect () {
    this.tabTargets.map((tab) => { tab.hidden = true })
    this.tabTargets[0].hidden = false
    this.btnTargets[0].classList.add('active')
  }

  select (event) {
    const selectedTab = this.tabTargets.find((tab) => {
      return tab.id === event.currentTarget.id
    })

    if (selectedTab.hidden) {
      this.tabTargets.map((tab) => { tab.hidden = true })
      this.btnTargets.map((btn) => btn.classList.remove('active'))

      selectedTab.hidden = false
      selectedTab.classList.remove('d-none')

      event.currentTarget.classList.add('active')
    }
  }
}
